import DropDownList from "@/components/Dropdown";
import { ListStatus } from "@/constants/default";
import { useGetDropDownCompaniesQuery } from "@/services/company.service";
import { BusinessUnitForm } from "@/types/businessunit.type";
import { UseFormRegister, FieldErrors, Controller, Control, useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import Rooms from "./_room";

export default function Information() {
    const {t} = useTranslation()
    const { data: companies } = useGetDropDownCompaniesQuery({}, {refetchOnFocus: true, refetchOnMountOrArgChange: true, refetchOnReconnect: true})
    const listStatus = ListStatus();
    const {register, formState: { errors }, control} = useFormContext<BusinessUnitForm>()

    return (
        <div className="overflow-y-auto max-h-[80vh] px-2">
            <div className="grid grid-cols-1 gap-9 sm:grid-cols-2 overflow-x-hidden overflow-y-auto mb-4">
                <div>
                    <div className="mb-2">
                        <label className="mb-1 block dark:text-white">
                            {t("businessunit.company")}
                        </label>
                        {
                            companies && <Controller
                                name="company_id"
                                control={control}
                                rules={{required: t("validation.required")}}
                                render={({field: {onChange, value}}) => <DropDownList selected={value} setSelected={onChange} list={companies} />}
                            />
                        }
                        { errors.company_id && <p className="mt-1 text-rose-600">{errors.company_id.message}</p>}
                    </div>
                    <div className="mb-2">
                        <label className="mb-1 block text-black dark:text-white">
                            {t("businessunit.name")}
                        </label>
                        <input
                            type="text"
                            placeholder={t("placeholder.business_unit_name")}
                            className="w-full rounded border-[1.5px] border-stroke bg-transparent py-1.5 px-2 outline-none transition focus:border-primary active:border-primary disabled:cursor-default disabled:bg-whiter dark:text-white dark:border-form-strokedark dark:bg-form-input dark:focus:border-primary"
                            {...register("name", {required: t("validation.required")})}
                        />
                        { errors.name && <p className="mt-1 text-rose-600">{errors.name.message}</p>}
                    </div>
                    <div className="mb-2">
                        <label className="mb-1 block text-black dark:text-white">
                            {t("businessunit.account")}
                        </label>
                        <input
                            type="text"
                            placeholder={t("placeholder.business_unit_account")}
                            className="w-full rounded border-[1.5px] border-stroke bg-transparent py-1.5 px-2 outline-none transition focus:border-primary active:border-primary disabled:cursor-default disabled:bg-whiter dark:text-white dark:border-form-strokedark dark:bg-form-input dark:focus:border-primary"
                            {...register("account", {required: t("validation.required")})}
                        />
                        { errors.account && <p className="mt-1 text-rose-600">{errors.account.message}</p>}
                    </div>
                    <div className="mb-2">
                        <label className="mb-1 block dark:text-white">
                            {t("form.status")}
                        </label>
                        <Controller
                            name="status"
                            control={control}
                            defaultValue={listStatus[1].value}
                            render={({field: {onChange, value}}) => <DropDownList selected={value} setSelected={onChange} list={listStatus} />}
                        />
                    </div>
                    <div className="mb-2">
                        <label className="mb-1 block text-black dark:text-white">
                            {t("businessunit.take_over")}
                        </label>
                        <input
                            type="date"
                            placeholder={t("placeholder.business_unit_account")}
                            className="custom-input-date-1 w-full rounded border-[1.5px] border-stroke bg-transparent py-1.5 px-2 outline-none transition focus:border-primary active:border-primary dark:border-form-strokedark dark:text-white dark:bg-form-input dark:focus:border-primary disabled:opacity-75"
                            {...register("take_over", {required: t("validation.required")})}
                        />
                        { errors.take_over && <p className="mt-1 text-rose-600">{errors.take_over.message}</p>}
                    </div>
                    <div className="mb-2">
                        <label className="mb-1 block text-black dark:text-white">
                            {t("form.description")}
                        </label>
                        <textarea
                            placeholder={t("placeholder.description")}
                            rows={7}
                            className="w-full rounded border-[1.5px] border-stroke bg-transparent py-1.5 px-2 outline-none transition focus:border-primary active:border-primary disabled:cursor-default disabled:bg-whiter dark:text-white dark:border-form-strokedark dark:bg-form-input dark:focus:border-primary"
                            {...register("description", {required: t("validation.required")})}
                        />
                        { errors.description && <p className="mt-1 text-rose-600">{errors.description.message}</p>}
                    </div>
                </div>
                <div>
                    <div className="mb-2">
                        <label className="mb-1 block text-black dark:text-white">
                            {t("businessunit.landlord_name")}
                        </label>
                        <input
                            type="text"
                            placeholder={t("placeholder.landlord_name")}
                            className="w-full rounded border-[1.5px] border-stroke bg-transparent py-1.5 px-2 outline-none transition focus:border-primary active:border-primary disabled:cursor-default disabled:bg-whiter dark:text-white dark:border-form-strokedark dark:bg-form-input dark:focus:border-primary"
                            {...register("landlord_name", {required: t("validation.required")})}
                        />
                        { errors.landlord_name && <p className="mt-1 text-rose-600">{errors.landlord_name.message}</p>}
                    </div>
                    <div className="mb-2">
                        <label className="mb-1 block text-black dark:text-white">
                            {t("businessunit.address")}
                        </label>
                        <input
                            type="text"
                            placeholder={t("placeholder.address")}
                            className="w-full rounded border-[1.5px] border-stroke bg-transparent py-1.5 px-2 outline-none transition focus:border-primary active:border-primary disabled:cursor-default disabled:bg-whiter dark:text-white dark:border-form-strokedark dark:bg-form-input dark:focus:border-primary"
                            {...register("address", {required: t("validation.required")})}
                        />
                        { errors.address && <p className="mt-1 text-rose-600">{errors.address.message}</p>}
                    </div>
                    <div className="mb-2">
                        <label className="mb-1 block text-black dark:text-white">
                            {t("businessunit.condo")}
                        </label>
                        <input
                            type="text"
                            placeholder={t("placeholder.condo")}
                            className="w-full rounded border-[1.5px] border-stroke bg-transparent py-1.5 px-2 outline-none transition focus:border-primary active:border-primary disabled:cursor-default disabled:bg-whiter dark:text-white dark:border-form-strokedark dark:bg-form-input dark:focus:border-primary"
                            {...register("condo")}
                        />
                        { errors.condo && <p className="mt-1 text-rose-600">{errors.condo.message}</p>}
                    </div>
                    <div className="mb-2">
                        <label className="mb-1 block text-black dark:text-white">
                            {t("businessunit.unit")}
                        </label>
                        <input
                            type="text"
                            placeholder={t("placeholder.unit")}
                            className="w-full rounded border-[1.5px] border-stroke bg-transparent py-1.5 px-2 outline-none transition focus:border-primary active:border-primary disabled:cursor-default disabled:bg-whiter dark:text-white dark:border-form-strokedark dark:bg-form-input dark:focus:border-primary"
                            {...register("unit")}
                        />
                        { errors.unit && <p className="mt-1 text-rose-600">{errors.unit.message}</p>}
                    </div>
                    <div className="mb-2">
                        <label className="mb-1 block text-black dark:text-white">
                            {t("businessunit.door_pin")}
                        </label>
                        <input
                            type="text"
                            placeholder={t("placeholder.door_pin")}
                            className="w-full rounded border-[1.5px] border-stroke bg-transparent py-1.5 px-2 outline-none transition focus:border-primary active:border-primary disabled:cursor-default disabled:bg-whiter dark:text-white dark:border-form-strokedark dark:bg-form-input dark:focus:border-primary"
                            {...register("door_pin")}
                        />
                        { errors.door_pin && <p className="mt-1 text-rose-600">{errors.door_pin.message}</p>}
                    </div>
                    <div className="mb-2">
                        <label className="mb-1 block text-black dark:text-white">
                            {t("businessunit.condo_card")}
                        </label>
                        <input
                            type="number"
                            placeholder={t("placeholder.condo_card")}
                            className="w-full rounded border-[1.5px] border-stroke bg-transparent py-1.5 px-2 outline-none transition focus:border-primary active:border-primary disabled:cursor-default disabled:bg-whiter dark:text-white dark:border-form-strokedark dark:bg-form-input dark:focus:border-primary"
                            {...register("condo_card")}
                        />
                        { errors.condo_card && <p className="mt-1 text-rose-600">{errors.condo_card.message}</p>}
                    </div>
                    <div className="mb-2">
                        <label className="mb-1 block text-black dark:text-white">
                            {t("businessunit.bank")}
                        </label>
                        <input
                            type="text"
                            placeholder={t("placeholder.bank")}
                            className="w-full rounded border-[1.5px] border-stroke bg-transparent py-1.5 px-2 outline-none transition focus:border-primary active:border-primary disabled:cursor-default disabled:bg-whiter dark:text-white dark:border-form-strokedark dark:bg-form-input dark:focus:border-primary"
                            {...register("bank", {required: t("validation.required")})}
                        />
                        { errors.bank && <p className="mt-1 text-rose-600">{errors.bank.message}</p>}
                    </div>
                    <div className="mb-2">
                        <label className="mb-1 block text-black dark:text-white">
                            {t("businessunit.bank_account")}
                        </label>
                        <input
                            type="text"
                            placeholder={t("placeholder.bank_account")}
                            className="w-full rounded border-[1.5px] border-stroke bg-transparent py-1.5 px-2 outline-none transition focus:border-primary active:border-primary disabled:cursor-default disabled:bg-whiter dark:text-white dark:border-form-strokedark dark:bg-form-input dark:focus:border-primary"
                            {...register("bank_account", {required: t("validation.required")})}
                        />
                        { errors.bank_account && <p className="mt-1 text-rose-600">{errors.bank_account.message}</p>}
                    </div>
                </div>
            </div>
            <Rooms />
        </div>
    )
}